import { Component, Input } from '@angular/core';
import { RmdAgeInfo } from '../../models/RmdAgeInfo';

@Component({
  standalone: false,
  selector: 'mm-rmd-age-date',
  templateUrl: './rmd-age-date.component.html',
  styleUrls: ['./rmd-age-date.component.scss']
})
export class RmdAgeDateComponent {
  @Input() rmdAgeInfo: RmdAgeInfo | null;
  title: string | undefined;
  date: string | undefined;

  ngOnInit(): void {
    if (!this.rmdAgeInfo?.cusAge59Indicator) {
      this.title = 'Age 59 1/2 on';
      this.date = this.rmdAgeInfo?.cusAge59On;
    }
    else if (!this.rmdAgeInfo?.cusAge70Indicator) {
      this.title = 'RMD required starting on';
      this.date = this.rmdAgeInfo?.cusAge70On;
    }
  }
}
